import { Component, OnInit, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { PlayerDataService } from '../../services/player-data.service';
import { PlayerApiService } from '../../services/player-api.service';
import { AuthService } from '../../services/auth.service';
import { firstValueFrom } from 'rxjs';
import { DecisionRecord } from '../../models/decision.model';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { UtilsService } from '../../services/utils.service';


@Component({
  selector: 'app-player-dashboard',
  templateUrl: './player-dashboard.component.html',
  styleUrls: ['./player-dashboard.component.css'],
  standalone: true,
  imports: [
    CommonModule,   // ✅ Needed for built-in pipes like 'number', 'date', 'currency', etc.
    FormsModule,
    RouterModule,
    NgbModalModule
  ],
})
export class PlayerDashboardComponent implements OnInit {
  /** Sidebar open/close status for mobile/tablet */
  isSidebarOpen: boolean = false;
  isRemarkOpen = false;
  remarksList: any[] = [];

  tabs: any[] = [
    { label: 'Entry', path: 'entryDecisions', enabled: true },
    { label: 'Finance', path: 'financeDecisions', enabled: true },
    { label: 'Sales & Marketing', path: 'marketingDecision', enabled: true },
    { label: 'People', path: 'peopleDecisions', enabled: true },
    { label: 'Production', path: 'productionDecisions', enabled: true },
    { label: 'Product', path: 'productDecisions', enabled: true },
    { label: 'R&D', path: 'RandDDecisions', enabled: true }
  ]
  currentRound: number = 0;
  compdtl: any;
  roundData: any;
  visited = new Set<string>();
  currentStatus: string = "";
  username: string = '';

  constructor(private playerData: PlayerDataService, private api: PlayerApiService, private authService: AuthService, private router: Router, private route: ActivatedRoute, private toaster: ToastrService, private modalService: NgbModal, public utils: UtilsService) { 
    // Auto-close sidebar when any route is navigated
    this.router.events.subscribe(() => {
      this.isSidebarOpen = false;
    });
  }

   // OPTIONAL methods if you want explicit functions
  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeSidebar() {
    this.isSidebarOpen = false;
  }

  async ngOnInit() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const playerId = user.userId;
    this.username = user.username;

    try {
      const compdtl = await firstValueFrom(this.api.getCompanyDetails(playerId));
      console.log("compdtl");
      console.log(compdtl);
      this.compdtl = compdtl.Data;
      this.currentRound = compdtl.Data[0].CurrentRound;
      this.utils.companyName = compdtl.Data[0].CompanyName;
      this.utils.round = compdtl.Data[0].CurrentRound;
       await this.getRemarks(compdtl.Data[0].SDBatchId, compdtl.Data[0].CurrentRound);
      console.log(compdtl);
      console.log(user);
      console.log(this.currentRound);
      this.roundData = await firstValueFrom(this.api.getDecisionData(playerId, this.currentRound));
      console.log(this.roundData);
      this.currentStatus = this.roundData.Data[0].Status;
      const newDecision: DecisionRecord = {
        header: {
          BatchId: 0,
          CompanyId: 0,
          RoundId: 0,
          status: 'Y',
          srno: 0
        },
        sections: [
          { sectionName: '', data: {} },
          { sectionName: '', data: {} },
          { sectionName: '', data: {} },
          { sectionName: '', data: {} },
          { sectionName: '', data: {} },
          { sectionName: '', data: {} },
          { sectionName: '', data: {} },
          { sectionName: '', data: {} },

        ],
      };

      this.playerData.setDecision(newDecision);

      this.playerData.setFullDecisionData(this.roundData.Data[0]);  // 👈 this is the key line
      console.log(this.currentRound);
      console.log(this.currentStatus);
      if (this.currentStatus === 'Y' || this.currentStatus === 'E') {
        this.tabs.forEach(tab => tab.enabled = tab.label === 'Entry');
      } else {
        this.tabs.forEach(tab => tab.enabled = tab.label !== 'Entry');
      }

      const firstEnabledTab = this.tabs.find(t => t.enabled);
      if (firstEnabledTab) {
        this.navigateTo(firstEnabledTab);
      }
      //this.configureTabs(this.currentRound, this.currentStatus );
    } catch (err) {
      console.error('Error loading player data', err);
    }

  }


  navigateTo(tab: any) {
    if (!tab.enabled) return;
    // relative navigation makes it go to /player-dashboard/<tab.path>
    this.router.navigate([tab.path], { relativeTo: this.route });
  }

  markVisited(path: string) {
    this.visited.add(path);
  }

  onSave() {
    const allData = this.playerData.getAllData();
    this.api.saveDraft(allData).subscribe({
      next: res => this.toaster.success('Draft saved successfully!', 'Success'),
      error: err => this.toaster.error('Save failed: ' + err.errorDescription, 'Error')
    });
  }

 //new
 

  onSubmit() {
    // const allData = this.playerData.getAllData();
    // this.api.submitPlayerData(allData).subscribe({
    //   next: res => this.toaster.success('Data submitted successfully!'),
    //   error: err => this.toaster.error('Submit failed: ' + err.message, 'Error')
    // });
    const confirmed = window.confirm('Are you sure you want to submit?');
    if (!confirmed) {
      return;
    }
    const allData = this.playerData.getAllData();
    this.api.submitPlayerData(allData).subscribe({
      next: res => this.toaster.success('Data submitted successfully!', 'Success'),
      error: err => this.toaster.error('Submit failed: ' + err.errorDescription, 'Error')
    });
  }

  onLogout() {
    this.authService.logout();
  }

  toggleRemarkPanel() {
  this.isRemarkOpen = !this.isRemarkOpen;
}



  getRemarks(batchId: number, roundId: number) {
    this.api.getRemarksList(batchId, roundId).subscribe((resp) => {
      // const remarks = JSON.parse(resp.Data[0].Remarkstr);
      // console.log(remarks,'remarks');
      
      this.remarksList = resp.Data;
    });
  }

  //  openSubmitModal(content: TemplateRef<any>) {

  //   const modalRef = this.modalService.open(content, {
  //     centered: true,
  //     backdrop: 'static',
  //     keyboard: false
  //   });

  //   modalRef.result.then((result) => {
  //     if (result === 'confirm') {
  //       this.onSubmit();
  //     }
  //   }).catch(() => {});
  // }



}
